import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../helper/api";

export const removeGameFavorite = createAsyncThunk(
  "removeGameFavorite/removeGameFavorite",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post('/removefavourite', payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const removeGameFavoriteSlice = createSlice({
  name: "removeGameFavorite",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(removeGameFavorite.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeGameFavorite.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(removeGameFavorite.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default removeGameFavoriteSlice.reducer;
